import { gql } from '@apollo/client';

export const AssetsFragment = gql`
  fragment assetFields on BrandAssets {
    logo {
      id
      url
      strategies
    }
    cover {
      id
      url
      strategies
    }
  }
`;

export const BrandDetailsFragment = gql`
  fragment brandDetails on Brand {
    id
    legacyId
    owner {
      id
      type
    }
    name
    state
    isDefault
    isLiveOnAd
    assets {
      ...assetFields
    }
  }
  ${AssetsFragment}
`;

export const BrandUpdateMutationFragment = gql`
  fragment brandDetails on UpdateBrandPayload {
    ... on UpdateBrandSuccessPayload {
      id
      legacyId
      owner {
        id
        type
      }
      name
      state
      isDefault
      assets {
        ...assetFields
      }
    }
    ... on InvalidInputPayload {
      reason
    }
  }
  ${AssetsFragment}
`;

// TODO: hotfix, clean it up!
export const BrandCreateMutationFragment = gql`
  fragment brandDetails on CreateBrandPayload {
    ... on CreateBrandSuccessPayload {
      id
      legacyId
      owner {
        id
        type
      }
      name
      state
      isDefault
      assets {
        ...assetFields
      }
    }
    ... on InvalidInputPayload {
      reason
    }
  }
  ${AssetsFragment}
`;
